import { render, staticRenderFns } from "./IrrigationPlanAdd.vue?vue&type=template&id=df0c48ca&scoped=true"
import script from "./IrrigationPlanAdd.vue?vue&type=script&lang=js"
export * from "./IrrigationPlanAdd.vue?vue&type=script&lang=js"
import style0 from "./IrrigationPlanAdd.vue?vue&type=style&index=0&id=df0c48ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0c48ca",
  null
  
)

export default component.exports